// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"033a8aae","667":"85c2c644","879":"b198a398","977":"8c8a2bb4"}[chunkId] + ".chunk.js";
};